<template>
  <ChartLine
    data-testid="chart-line-testid"
    :chartData="chartData"
    :options="chartOptions"
  />
</template>

<script>
import ChartLine from './chartConfig'
import { STEPS } from '../../../../views/Home/Charges/charge.enum'

const handleDataset = (data, labels) => ({
  labels,
  type: 'line',
  datasets: [
    {
      data,
      tension: 0.5,
      borderColor: '#30A46C',
      radius: 1,
      pointBorderWidth: 4,
      borderWidth: 2,
      fill: true,
      grid: {
        display: true,
        drawOnChartArea: false,
        drawTicks: true
      },
      backgroundColor: ctx => {
        const canvas = ctx.chart.ctx
        const gradient = canvas.createLinearGradient(0, 0, 0, 350)

        gradient.addColorStop(0, 'rgba(48, 164, 108, .3)')
        gradient.addColorStop(1, 'rgba(48, 164, 108, .1)')

        return gradient
      }
    }
  ]
})

const handleLabelTooltip = (tooltipItem, tooltipConfig, data) => {
  const { currencyDisplay, currencySymbol, format } = tooltipConfig

  const value = data[tooltipItem.index]

  const currency = format?.(value) ?? value

  const label = currencyDisplay ? `${currencySymbol} ${currency}` : currency

  return `${label ?? value}`
}

const handleLabelYAxes = (value, yAxisOptions) => {
  const { currencyDisplay, currencySymbol, format, step } = yAxisOptions

  const stepValue = step === STEPS.ROUND ? Math.round(value) : value
  const currency = format?.(stepValue) ?? stepValue

  const currencyFormat =
    typeof currency === 'string'
      ? currency?.replace(currencySymbol, '')
      : currency

  const label = currencyDisplay ? currency : currencyFormat
  return label ?? stepValue
}

export default {
  components: {
    ChartLine
  },

  props: {
    data: {
      type: Array,
      required: true
    },
    xlabels: {
      type: Array,
      required: true
    },
    height: {
      type: Number,
      default: 100
    },
    yAxisOptions: Object,
    tooltipConfig: Object
  },

  data () {
    return {
      chartData: handleDataset(this.data, this.xlabels),
      chartOptions: {
        responsive: true,
        tooltips: {
          enabled: true,
          callbacks: {
            label: tooltipItem =>
              handleLabelTooltip(tooltipItem, this.tooltipConfig, this.data)
          }
        },
        bezierCurve: false,
        maintainAspectRatio: false,
        legend: {
          display: false,
          labels: {
            usePointStyle: false
          }
        },
        scales: {
          xAxes: [
            {
              ticks: {
                fontColor: 'rgb(139, 139, 146)'
              },
              gridLines: {
                display: false,
                drawTicks: true
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                callback: value => handleLabelYAxes(value, this.yAxisOptions),
                fontColor: 'rgb(139, 139, 146)',
                beginAtZero: true // minimum value will be 0.
              },
              gridLines: {
                display: true,
                drawTicks: true,
                borderDash: [8, 4],
                borderDashOffset: 1.8
              }
            }
          ]
        },
        interaction: {
          intersect: false
        }
      }
    }
  },

  computed: {
    heightSize: () => (window.innerWidth > 768 ? 250 : 350)
  },

  watch: {
    data (newValue) {
      this.chartData = handleDataset(newValue, this.xlabels)
    }
  }
}
</script>
